import { useMemo } from "react";

import {
  type ChallengeIdeaFiltersState,
  useChallengeIdeaFilters,
} from "stores/challengeIdeaFilters";

import type { ChallengeIdeaQueryParams } from "../../types";

export const useIdeaQueryParams = (
  ideaViewType: ChallengeIdeaFiltersState["ideaViewType"],
): ChallengeIdeaQueryParams => {
  const ideaFilters = useChallengeIdeaFilters();

  return useMemo(
    () => ({
      ideaViewType,
      page: ideaViewType === "board" ? 1 : ideaFilters.page,
      query: ideaFilters.query,
      tags: ideaFilters.tags,
      status: ideaFilters.status,
      sort: ideaFilters.sort,
      sortDirection: ideaFilters.sortDirection,
      labels: ideaFilters.labels,
      authorGroupIds: ideaFilters.authorGroupIds,
      authorOrganisationIds: ideaFilters.authorOrganisationIds,
      fieldChoices: ideaFilters.fieldChoices,
      limit: ideaViewType === "board" ? 10000 : ideaFilters.limit,
      hasAdminComment: ideaFilters.hasAdminComment,
      hasCustomDeadline: ideaFilters.hasCustomDeadline,
      assignees: ideaFilters.assignees,
      lanes: ideaFilters.lanes,
      impactIds: ideaFilters.impactIds,
      statusFilter: ideaFilters.statusFilter,
    }),
    [ideaViewType, ideaFilters],
  );
};
